import { ConnectScreens } from '@pff-consumer/schema'

export const getScreenNameFromPath = (path: string) => {
  switch (path) {
    case '/':
      return ConnectScreens.USAGE_VIEW
    case '/game':
      return ConnectScreens.GAME_VIEW
    case '/player':
      return ConnectScreens.PLAYER_VIEW
    case '/team':
      return ConnectScreens.TEAM_VIEW
    case '/live':
      return ConnectScreens.USAGE_VIEW
    case '/team-insights':
      return ConnectScreens.TEAM_INSIGHTS_VIEW
    default:
      return ''
  }
}
